module.exports = __webpack_public_path__ + "img/monbaceco2.5624f4a3.png";